<template>
    <div>
		<form-sidebar>
			<v-layout wrap>
				<v-subheader>Recurso: {{ resourceName }}</v-subheader>
			</v-layout>
			<v-layout wrap>
				<v-flex xs12 pb-3>
					<role-access-action-list
						:check-all="checkAll"
						:columns="columns"
						:rows="actions"
						:selected-value="selectedValue"
						@all-is-selected="allIsSelected"
						@on-search="onSearchList"
						@row-is-selected="rowIsSelected"
					/>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="loading"
					:on-run-service="loading"
					@accept-button-clicked="submitForm"
					@cancel-button-clicked="closeModal"
				/>
			</section>
		</form-sidebar>
    </div>
</template>

<script>
	import roleAccessActionList from '@/components/roles/role-access-action-list';

	
	function created() {
		this.actionParams.codeProject = this.codeProject;
		this.actionParams.resourceId = this.resourceId;
		this.actionParams.roleId = this.roleId;
		this.loadActions();
	}

	function allIsSelected(checked) {
		this.checkAll = checked;
		this.actions = this.selectIsRow(this.actions, this.selectedValue, false, checked);
	}

	async function loadActions() {
		const params = this.actionParams;
		const headers = this.version;
		try {
			const { data: actions } = await this.$http.get('action-list', { params, headers });
			this.actions = actions.data.map((action) => {
				const newAction = { ...action };
				const keyLanguages = Object.keys(action.languages);
				const firstLanguages = keyLanguages[0];
				newAction[this.selectedValue] = action[this.selectedValue] === 1;
				newAction.name = action.languages.es ? action.languages.es.name
					: action.languages[firstLanguages].name;
				return newAction;
			});
			this.checkAll = this.every(this.actions, this.selectedValue);
		} catch (err) {
			this.showError();
		}
	}

	function onSearchList(value) {
		this.actionParams.search = value;
		this.loadActions();
	}

	function rowIsSelected(row) {
		this.actions = this.selectIsRow(this.actions, this.selectedValue, row);
		this.checkAll = this.every(this.actions, this.selectedValue);
	}

	async function submitForm() {
		const actionsArray = this.actions.map(({ id, flagSelected }) => ({ id, flagSelected }));
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const params = {
			actions: actionsArray,
			roleId: Number(this.roleId),
		};
		this.loading = true;
		try {
			await this.$http.post(`resource/${this.resourceId}/actions`, params, { headers });
			this.showNotification('La barra de acciones ha sido asignada correctamente');
		} finally {
			this.loading = false;
		}
	}

	function closeModal() {
		this.$emit('close-modal');
	}

	function data() {
		return {
			actionParams: {
				codeProject: '',
				resourceId: 0,
			},
			actions: [],
			checkAll: false,
			columns: [
				{ id: 1, name: 'Nombre', checked: true, visible: true },
				{ id: 2, name: 'Código', checked: true, visible: true },
				{ id: 3, name: 'Url Web', checked: true, visible: true },
				{ id: 4, name: 'Fragment Móvil', checked: true, visible: true },
			],
			loading: false,
			selectedValue: 'flagSelected',
			version: {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			},
		};
	}

	export default {
		name: 'role-access-action',
		components: {
			roleAccessActionList,
		},
		created,
		data,
		methods: {
			allIsSelected,
			closeModal,
			loadActions,
			onSearchList,
			rowIsSelected,
			submitForm,
		},
		props: {
			codeProject: {
				type: String,
				required: true,
			},
			resourceId: {
				type: [Number, String],
				required: true,
			},
			resourceName: {
				type: String,
				required: true,
			},
			roleId: {
				type: [Number, String],
				required: true,
			},
		},
	};
</script>




// WEBPACK FOOTER //
// src/components/roles/role-access-action.vue